import type { ChangeEvent } from 'react';
import type { CheckboxOnChangeArg } from '@library/types/utils';
import { cn } from '@library/component-utils/cn';

export interface CheckboxProps extends React.ComponentPropsWithoutRef<'input'> {
  checked?: boolean;
  checkAll?: boolean;
  className?: string;
  disabled?: boolean;
  id: string;
  label?: string;
  labelClassName?: string;
  onCheckboxChange: ({ id, checked }: CheckboxOnChangeArg) => void;
  wrapperClassName?: string;
}

export function Checkbox({
  checked = false,
  checkAll = false,
  className = '',
  disabled = false,
  id,
  label = '',
  labelClassName = '',
  onCheckboxChange,
  wrapperClassName = '',
  ...rest
}: CheckboxProps) {
  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { id: inputId, checked: isChecked } = e.target;
    onCheckboxChange({ id: inputId, checked: isChecked });
  };

  return (
    <div className={cn(wrapperClassName, 'text-soClean-100 text-sm')}>
      <input
        checked={checked}
        className={cn(
          'border-soFresh-150 !color-transparent focus:!outline-hidden size-5 cursor-pointer rounded border border-solid bg-transparent hover:bg-inherit disabled:cursor-not-allowed',
          checkAll ? 'checked:bg-selectAll' : '',
          className,
          disabled
            ? 'checked:focus:bg-soClean-180 checked:hover:bg-soClean-180 checked:bg-soClean-180 focus:ring-transparent focus:ring-offset-transparent focus-visible:ring-transparent'
            : 'checked:focus:bg-stankonia-100 checked:hover:bg-stankonia-100 checked:bg-stankonia-100 focus:ring-stankonia-100 focus:ring-offset-soClean-110 focus-visible:ring-stankonia-100'
        )}
        id={id}
        onChange={handleOnChange}
        type="checkbox"
        disabled={disabled}
        {...rest}
      />
      <label
        className={cn(
          disabled ? 'text-soClean-190' : '',
          'ml-2.5',
          labelClassName
        )}
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  );
}
